import { COUPON_OFFERS, REWARD_OFFERING } from "../../constants";
import OnboardingPage from "../../common/components/OnboardingPage";
import { RetrieveCoupon } from "../../common/utils/RetrieveCoupon";

function SuperCheapAutoTactical2Main() {
  const { loading, coupon } = RetrieveCoupon(COUPON_OFFERS.supercheapautotactical2);
  const redeemUrl = GLOBAL_CFG["supercheap-auto-tactical-2"].redeem.redeemUrl;

  return (
    <>
      {!loading && (
          <OnboardingPage
            partnerCfg={GLOBAL_CFG["supercheap-auto-tactical-2"]}
            redeemUrl={redeemUrl}
            coupon={coupon}
            rewardId={REWARD_OFFERING.supercheapautotactical2}
          />
      )}
    </>
  );
}

export default SuperCheapAutoTactical2Main;
